import Swal from 'sweetalert2';

const NotificationService = {
  showSuccess(message = 'Success!') {
    Swal.fire({
      toast: true,
      position: 'top-end',
      icon: 'success',
      title: message,
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
    });
  },

  /**
   * Most callers pass `error?.response?.data?.message`. When a request fails at
   * the network layer — offline, timeout, or a response the browser refuses to
   * expose because it lacks CORS headers — axios has no `response` at all, so
   * that expression is `undefined` and the toast used to render as a bare
   * "Error!" with nothing else. That told the user nothing and told us nothing.
   *
   * A default parameter cannot fix this at the call sites, because `undefined`
   * is exactly what triggers it. So substitute here instead, and log the real
   * cause to the console for whoever is debugging.
   */
  showError(message) {
    const text = (typeof message === 'string' && message.trim())
      ? message.trim()
      : 'Something went wrong. The server could not be reached, or returned no details.';

    if (!(typeof message === 'string' && message.trim())) {
      // eslint-disable-next-line no-console
      console.warn('[notification] showError called without a message —',
        'likely a network/CORS failure with no response body.');
    }

    Swal.fire({
      toast: true,
      position: 'top-end',
      icon: 'error',
      title: text,
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
    });
  }
};

export default NotificationService;
